import { useState, useEffect, CSSProperties, useRef } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import RouteConstant from "../../constants/route.constants";
import { UserAddress } from "../../models/user-address-model";
import AddressSelector from "./address-selector";
import { useTranslation } from "react-i18next";
import UserAddressService from "../../services/useraddress/useraddress.service";
import { ProductCheckoutProceedModel } from "../../models/products/product-checkout-proceed-model";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { selectUserAddress } from "../../redux/slices/user-address";
import ProductStorageHelpers from "../../utils/product-local-storage-wrapper";
import ClipLoader from "react-spinners/ClipLoader";
import { Toast } from "primereact/toast";

const AddressLists = (props: any) => {
  const [addressList, setAddressList] = useState<UserAddress[]>([]);
  const [selectedId, setSelectedId] = useState<number>();
  const [loader, setLoader] = useState<boolean>();
  const toast = useRef<Toast>(null);
  const { t } = useTranslation();
  var navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isUseThisAddress, setIsUseThisAddress] = useState(false);
  const selectedAdminUserId = useAppSelector((state) => state.adminUser);
  const override: CSSProperties = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
  };
 
  const getAddreses = (addressId?: number) => {
    const storedAddressId = localStorage.getItem('selectedAddressId');
    const idToUse = addressId || (storedAddressId ? parseInt(storedAddressId) : undefined);
    const adminUserId = selectedAdminUserId?.selectedAdminUserId;
    setLoader(true);
    if (adminUserId) {
      UserAddressService.getUserAddressById(adminUserId)
        .then((response: any) => {
          if (response !== null) {
            const result = response.filter((req: any) => !req.isDeleted);
            setSelectedId(idToUse || result[result.length - 1]?.userAddressID);
            setAddressList(result);
          }
          setLoader(false);
        }).catch((error: any) => {
          setLoader(false)
        });
    } 
    else {
              UserAddressService.getUserAddress(0)
                .then((response: any) => {
                  if (response !== null) {
                    const result = response.filter((req: any) => !req.isDeleted);
                    setSelectedId(idToUse || result[result.length - 1]?.userAddressID);
                    setAddressList(result);
                  }
                  setLoader(false);
                })
                .catch((error: any) => {
                  setLoader(false);
                });
          }
};

  useEffect(() => {
    getAddreses();
    const orderedData = ProductStorageHelpers.GetProcessedProductStorage();
    if (orderedData !== null) {
      setIsUseThisAddress(true);
    } else {
      setIsUseThisAddress(false);
    }
  }, []);

  const getPaymentMode = () => {
    const orderedData = ProductStorageHelpers.GetProcessedProductStorage();
    if (!orderedData || !orderedData.items || orderedData.items.length === 0) {
      toast.current?.show({
        severity: 'info',
        summary: 'Empty Cart',
        detail: 'Your cart is empty. Please add items before proceeding.',
        life: 3000
      });
        return;
    }

    const filterData = addressList.filter(
        (item) => item.userAddressID === selectedId
    );

    if (filterData.length === 0) {
        console.error("No matching address found for selectedId:", selectedId);
        return;
    }
    setSelectedUserAddress(filterData[0]);
    loadPaymentOption(filterData[0]);
    navigate(RouteConstant.courierProviderList);
};

  const setSelectedUserAddress = (data: UserAddress) => {
    dispatch(selectUserAddress(data));
    localStorage.setItem('selectedAddressId', data.userAddressID.toString());
  };

  const loadPaymentOption = (filterData: UserAddress) => {
    const orderedData = ProductStorageHelpers.GetProcessedProductStorage();
    if (orderedData !== null) {
      let data: ProductCheckoutProceedModel = orderedData;
      data.address.userAddressID = filterData.userAddressID;
      data.address.createdBy = filterData.createdBy;
      data.address.userName = filterData.userName;
      data.address.address1 = filterData.address1;
      data.address.address2 = filterData.address2;
      data.address.landmark = filterData.landmark;
      data.address.countryName = filterData.countryName;
      data.address.stateName = filterData.stateName;
      data.address.areaName = filterData.areaName;
      data.address.subDisticName = filterData.subDisticName;
      data.address.zipcode = filterData.zipcode;
      data.address.gpsLocation = filterData.gpsLocation;
      data.address.isPrimary = filterData.isPrimary;
      data.address.cityName = filterData.cityName;
      data.address.homeDeliveryAvailable = filterData.homeDeliveryAvailable;
      ProductStorageHelpers.SetProcessedProductStorage(data);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      {loader ?
        <div className="flex align-items-center p-4">
          <ClipLoader
            loading={loader}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
            cssOverride={override}
            color="#90ee90" />
        </div>
        :
        <Card
          title={t("useraddress_your_addresses")}
          className="user-address-card border-1 surface-border h-full"
        >
          {addressList.length === 0 && (
            <div className="flex align-items-center line-height-3  p-3 text-lg border-round box-info">
              <i className="pi pi-info-circle text-md mr-2"></i>
              No addresses found. Please click on below link to add a new address.
            </div>
          )}
          {addressList.length > 0 &&
            addressList
              .sort((a, b) => (a.userAddressID < b.userAddressID ? 1 : -1))
              .map((item) => {
                return (
                  <AddressSelector
                    id={item.userAddressID}
                    name={item.userName}
                    key={item.userAddressID + ""}
                    addressLine1={item.address1}
                    addressLine2={item.address2}
                    landmark={item.landmark}
                    areaName={item.areaName}
                    subDisticName={item.subDisticName}
                    cityName={item.cityName}
                    country={item.countryName}
                    state={item.stateName}
                    city={item.cityName}
                    selectedId={selectedId}
                    pincode={item.zipcode}
                    areaId={item.areaId}
                    // areaName={item.areaName}
                    getAddreses={getAddreses}
                    addressSelect={setSelectedId}
                  />
                );
              })}

          <div className="add-refresh-container mt-4">
            <div
              className="add-address-link"
              onClick={() => navigate(RouteConstant.addAddress1)}
            >
              <i className="pi pi-plus"></i>
              <span className="text-blue-500 font-semibold">
                {" "} 
                {t("useraddress_add_a_new_address")}{" "}
              </span>
            </div>
          </div>
          {addressList.length > 0 && isUseThisAddress ? (
            <div className="p-inputgroup justify-content-start">
              <Button
                label={t("useraddress_use_this_address")}
                className="checkout-btn"
                onClick={() => getPaymentMode()}
                raised
                icon="pi pi-envelope"
              />
            </div>
          ) : null}
        </Card>
      }
    </>
  );
};
// 

export default AddressLists;
